import React from 'react'
import { addLocaleData } from 'react-intl'
import localeData from 'react-intl/locale-data/en'

import Layout from './index'
import messages from '../i18n/en.json'

addLocaleData(localeData)

export default props => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('locale', 'en')
  }

  return <Layout {...props} locale="en" messages={messages} />
}

export const query = graphql`
  query AllImages {
    allImageSharp {
      edges {
        node {
          sizes {
            base64
            aspectRatio
            src
            srcSet
            sizes
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/en.js